export default "__VITE_ASSET__CLU$naVF__"